import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
const services = [{
  title: "Expatriation Strategy",
  description: "Designing compliant frameworks for global mobility, ensuring your move is structured for long-term freedom and clarity.",
  href: "/FrameworkPage"
}, {
  title: "Corporate Structuring",
  description: "Multi-jurisdictional entity formation and optimization to align business activities with your international lifestyle.",
  href: "/FrameworkPage"
}, {
  title: "Wealth & Tax Planning",
  description: "Sustainable asset protection and fiscal efficiency strategies tailored for the globally mobile entrepreneur.",
  href: "/FrameworkPage"
}, {
  title: "Residency & Visa Advice",
  description: "Securing residence rights and citizenship across borders to guarantee access, stability, and sovereignty.",
  href: "/FrameworkPage"
}];
export default function ArchitectingYourFuture() {
  return <section id="architecting-your-future" className="hidden bg-background py-24 md:py-32">
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-20 max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-serif text-foreground mb-6 tracking-tight">
            Architecting Your Future
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed max-w-2xl">
            We help clients align residency, business activities, legal structures, and long-term life objectives into a coherent and fully compliant international framework.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {services.map((service, i) => <Link key={i} to={service.href} className="block group h-full outline-none">
              <Card data-index={i} className={cn("h-full bg-white dark:bg-card border border-border rounded-sm", "transition-all duration-500 ease-out", "hover:shadow-xl hover:-translate-y-1", "relative overflow-hidden")}>
                <CardContent className="p-10 flex flex-col h-full justify-between gap-10">
                  <div>
                    <h3 className="font-serif text-[28px] text-foreground leading-tight mb-4 group-hover:text-primary transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed text-base">
                      {service.description}
                    </p>
                  </div>
                  
                  <div className="flex items-center gap-3 overflow-hidden pt-2">
                    <span className="text-xs font-bold uppercase tracking-widest text-foreground/70 group-hover:text-foreground transition-colors">
                        Explore
                    </span>
                    <ArrowRight className="w-5 h-5 text-[var(--ring)] transition-all duration-500 ease-out opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0" />
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}